import { useEffect, useState } from "react";
import { Trash2, X } from "lucide-react";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";

const inp = "border border-slate-200 rounded-md px-2 py-1.5 text-sm bg-white text-slate-800 " +
  "focus:outline-none focus:ring-2 focus:ring-sky-300 transition-colors duration-200";
const TABS = [["fonti", "Fonti"], ["competitor", "Competitor"]];

function TabFonti() {
  const [rows, setRows] = useState([]);
  const [nuova, setNuova] = useState({ nome: "", url: "", query: "", tipo: "editoriale",
    autorevolezza: 65 });
  const carica = () => api.get("/news/admin/fonti").then((r) => setRows(r.data.rows || []));
  useEffect(() => { carica(); }, []);
  const salva = async () => {
    try {
      await api.post("/news/admin/fonti", nuova);
      setNuova({ nome: "", url: "", query: "", tipo: "editoriale", autorevolezza: 65 });
      toast.success("Fonte aggiunta");
      carica();
    } catch (e) { toast.error(apiError(e)); }
  };
  const attiva = async (f) => {
    await api.put(`/news/admin/fonti/${f.key}`, { attiva: !f.attiva });
    carica();
  };
  const elimina = async (f) => {
    if (!window.confirm(`Eliminare la fonte ${f.nome}?`)) return;
    await api.delete(`/news/admin/fonti/${f.key}`);
    carica();
  };
  return (
    <div data-testid="gestione-fonti">
      <div className="grid grid-cols-1 lg:grid-cols-6 gap-2 items-center mb-4 p-3 rounded-lg bg-slate-50">
        <input className={inp} placeholder="Nome fonte" value={nuova.nome} data-testid="fonte-nome"
          onChange={(e) => setNuova({ ...nuova, nome: e.target.value })} />
        <input className={inp} placeholder="URL feed RSS (opzionale)" value={nuova.url}
          data-testid="fonte-url" onChange={(e) => setNuova({ ...nuova, url: e.target.value })} />
        <input className={inp} placeholder="oppure parole da monitorare" value={nuova.query}
          data-testid="fonte-query" onChange={(e) => setNuova({ ...nuova, query: e.target.value })} />
        <select className={inp} value={nuova.tipo} data-testid="fonte-tipo"
          onChange={(e) => setNuova({ ...nuova, tipo: e.target.value })}>
          <option value="istituzionale">Istituzionale</option>
          <option value="editoriale">Editoriale</option>
          <option value="aziendale">Aziendale / Comunicati</option>
          <option value="ricerca">Ricerca su aggregatore</option>
        </select>
        <input className={inp} type="number" min="0" max="100" value={nuova.autorevolezza}
          data-testid="fonte-autorevolezza"
          onChange={(e) => setNuova({ ...nuova, autorevolezza: Number(e.target.value) })} />
        <button onClick={salva} data-testid="fonte-salva" disabled={!nuova.nome}
          className="bg-slate-900 text-white rounded-md px-3 py-1.5 text-sm hover:bg-slate-800
            disabled:opacity-50 transition-colors duration-200">Aggiungi fonte</button>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-slate-500 uppercase text-[10px] tracking-wider">
            <tr>
              <th className="text-left px-3 py-2">Fonte</th>
              <th className="text-left px-3 py-2">Tipo</th>
              <th className="text-left px-3 py-2">Autorev.</th>
              <th className="text-left px-3 py-2">Ultimo controllo</th>
              <th className="text-left px-3 py-2">Stato</th>
              <th className="px-3 py-2" />
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {rows.map((f) => (
              <tr key={f.key} data-testid={`fonte-row-${f.key}`}>
                <td className="px-3 py-2 text-slate-700">{f.nome}</td>
                <td className="px-3 py-2 text-slate-500">{f.tipo}</td>
                <td className="px-3 py-2 font-mono">{f.autorevolezza}</td>
                <td className="px-3 py-2 text-xs text-slate-500">
                  {f.ultimo_controllo ? new Date(f.ultimo_controllo).toLocaleString("it-IT") : "—"}
                  {f.ultimo_errore && <span className="text-red-600"> · {f.ultimo_errore}</span>}
                  {!f.ultimo_errore && f.articoli_ultimo_giro !== undefined
                    && <span className="text-emerald-600"> · {f.articoli_ultimo_giro} elementi</span>}
                </td>
                <td className="px-3 py-2">
                  <button onClick={() => attiva(f)} data-testid={`fonte-toggle-${f.key}`}
                    className={`text-xs px-2 py-1 rounded transition-colors duration-200 ${f.attiva
                      ? "bg-emerald-50 text-emerald-700" : "bg-slate-100 text-slate-500"}`}>
                    {f.attiva ? "Attiva" : "Disattivata"}
                  </button>
                </td>
                <td className="px-3 py-2 text-right">
                  <button onClick={() => elimina(f)} data-testid={`fonte-elimina-${f.key}`}
                    className="text-slate-400 hover:text-red-600 transition-colors duration-200">
                    <Trash2 size={14} />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function TabCompetitor() {
  const [rows, setRows] = useState([]);
  const [nuovo, setNuovo] = useState({ nome: "", query: "" });
  const carica = () => api.get("/news/admin/competitor").then((r) => setRows(r.data.rows || []));
  useEffect(() => { carica(); }, []);
  const salva = async () => {
    try {
      await api.post("/news/admin/competitor", nuovo);
      setNuovo({ nome: "", query: "" });
      toast.success("Competitor aggiunto: verrà monitorato dal prossimo aggiornamento");
      carica();
    } catch (e) { toast.error(apiError(e)); }
  };
  return (
    <div data-testid="gestione-competitor">
      <div className="flex flex-wrap gap-2 items-center mb-4 p-3 rounded-lg bg-slate-50">
        <input className={inp} placeholder="Nome competitor" value={nuovo.nome}
          data-testid="competitor-nome" onChange={(e) => setNuovo({ ...nuovo, nome: e.target.value })} />
        <input className={`${inp} flex-1 min-w-[220px]`} placeholder="Parole da monitorare (opzionale)"
          value={nuovo.query} data-testid="competitor-query"
          onChange={(e) => setNuovo({ ...nuovo, query: e.target.value })} />
        <button onClick={salva} disabled={!nuovo.nome} data-testid="competitor-salva"
          className="bg-slate-900 text-white rounded-md px-3 py-1.5 text-sm hover:bg-slate-800
            disabled:opacity-50 transition-colors duration-200">Aggiungi competitor</button>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2">
        {rows.map((c) => (
          <div key={c.key} data-testid={`competitor-row-${c.key}`}
            className="flex items-center justify-between gap-2 border border-slate-200 rounded-md px-3 py-2">
            <span className="text-sm text-slate-700">{c.nome}</span>
            <span className="flex items-center gap-2">
              <button data-testid={`competitor-toggle-${c.key}`}
                onClick={async () => { await api.put(`/news/admin/competitor/${c.key}`,
                  { attivo: !c.attivo }); carica(); }}
                className={`text-xs px-2 py-1 rounded transition-colors duration-200 ${c.attivo
                  ? "bg-emerald-50 text-emerald-700" : "bg-slate-100 text-slate-500"}`}>
                {c.attivo ? "Attivo" : "Off"}
              </button>
              <button data-testid={`competitor-elimina-${c.key}`}
                onClick={async () => {
                  if (!window.confirm(`Eliminare ${c.nome}?`)) return;
                  await api.delete(`/news/admin/competitor/${c.key}`); carica();
                }}
                className="text-slate-400 hover:text-red-600 transition-colors duration-200">
                <Trash2 size={14} />
              </button>
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default function NewsGestione({ onClose }) {
  const [tab, setTab] = useState("fonti");
  return (
    <div className="fixed inset-0 z-50 bg-slate-900/40 flex items-start justify-center p-4 overflow-y-auto"
      data-testid="news-gestione-modal">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-6xl my-8">
        <div className="flex items-center justify-between px-6 py-4 border-b border-slate-200">
          <h2 className="text-lg font-semibold text-slate-900">Gestione sezione News</h2>
          <button onClick={onClose} data-testid="gestione-chiudi"
            className="text-slate-400 hover:text-slate-900 transition-colors duration-200">
            <X size={18} />
          </button>
        </div>
        <div className="px-6 pt-4 flex gap-2">
          {TABS.map(([k, l]) => (
            <button key={k} onClick={() => setTab(k)} data-testid={`gestione-tab-${k}`}
              className={`px-3 py-1.5 rounded-md text-sm transition-colors duration-200 ${tab === k
                ? "bg-slate-900 text-white" : "text-slate-600 hover:bg-slate-100"}`}>
              {l}
            </button>
          ))}
        </div>
        <div className="p-6">
          {tab === "fonti" ? <TabFonti /> : <TabCompetitor />}
        </div>
      </div>
    </div>
  );
}
